export enum CreditRequestType {
    CreditRequest = 1,
    ReturnToVendor = 2,
  }
  